<template>
    <ul class="cluster-question-list">
        <li v-for="item in questionData" :key="item.questionId">
            <Checkbox class="all-check" @valueChange="checkHandler($event, item)" :data="item.checked" />
            <div class="question-item" @mousemove="showQuestionDetail(item.questionId)" @mouseout="hideQuestionDetail" ref="quesMessage">
                <div class="question-item-text" :class="{ 'item-text-blue': item.isYester }">{{ item.questionText }}</div>
            </div>
            <div class="question-item-detail" v-show="item.questionId === currentQuesId">{{ item.questionText }}</div>
        </li>
    </ul>
</template>

<script>
import Checkbox from "@/views/zhiji/bComponents/checks/Checkbox";

export default {
    name: "ClusterQuestionList",
    props: ["data"],
    components: {
        Checkbox
    },
    data() {
        return {
            isShowDetail: false,
            currentQuesId: ""
        };
    },
    computed: {
        questionData() {
            return this.data;
        }
    },
    methods: {
        checkHandler(event, data) {
            this.$emit("checkChange", {
                checked: event.checked,
                questionId: data.questionId
            });
        },
        showQuestionDetail(questionId) {
            this.currentQuesId = questionId;
        },
        hideQuestionDetail() {
            this.currentQuesId = "";
        }
    }
};
</script>

<style lang="scss" scoped>
.cluster-question-list {
    font-size: 12px;
    padding: 4px 0;
    height: 271px;
    li {
        position: relative;
        display: flex;
        padding: 3px 24px;
        box-sizing: border-box;

        .question-item {
            position: relative;
            margin-left: 12px;
            flex: 1;
            overflow: hidden;

            .question-item-text {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
            .item-text-blue {
                color: #2088f3;
            }
        }
        .question-item-detail {
            position: absolute;
            background: #fff;
            border-radius: 4px;
            padding: 5px 8px;
            left: 0;
            top: 16px;
            margin: 8px 8px 0 54px;
            white-space: normal;
            word-break: break-all;
            word-wrap: break-word;
            box-shadow: 0 0 8px 0 rgba(90, 98, 111, 0.25);
            z-index: 1;
        }
    }
}
</style>
